"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IgnoreEqualValuesProperty = void 0;

var stringify_1 = require("../../utils/stringify");

var PreconditionFailure_1 = require("../precondition/PreconditionFailure");

function fromSyncCached(cachedValue) {
  return cachedValue === null ? new PreconditionFailure_1.PreconditionFailure() : cachedValue;
}

function fromCached() {
  for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
    data[_key] = arguments[_key];
  }

  if (data[1]) return data[0].then(fromSyncCached);
  return fromSyncCached(data[0]);
}

function fromCachedUnsafe(cachedValue, isAsync) {
  return fromCached(cachedValue, isAsync);
}

var IgnoreEqualValuesProperty = /*#__PURE__*/function () {
  function IgnoreEqualValuesProperty(property, skipRuns) {
    _classCallCheck(this, IgnoreEqualValuesProperty);

    this.property = property;
    this.skipRuns = skipRuns;
    this.coveredCases = new Map();
  }

  _createClass(IgnoreEqualValuesProperty, [{
    key: "isAsync",
    value: function isAsync() {
      return this.property.isAsync();
    }
  }, {
    key: "generate",
    value: function generate(mrng, runId) {
      return this.property.generate(mrng, runId);
    }
  }, {
    key: "shrink",
    value: function shrink(value) {
      return this.property.shrink(value);
    }
  }, {
    key: "run",
    value: function run(v) {
      var stringifiedValue = (0, stringify_1.stringify)(v);

      if (this.coveredCases.has(stringifiedValue)) {
        var lastOutput = this.coveredCases.get(stringifiedValue);

        if (!this.skipRuns) {
          return lastOutput;
        }

        return fromCachedUnsafe(lastOutput, this.property.isAsync());
      }

      var out = this.property.run(v);
      this.coveredCases.set(stringifiedValue, out);
      return out;
    }
  }]);

  return IgnoreEqualValuesProperty;
}();

exports.IgnoreEqualValuesProperty = IgnoreEqualValuesProperty;